/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lat: NonNullable<unknown>, lng: NonNullable<unknown> }} Map_Search_CoordsInputs */

const vi_map_search_coords = /** @type {(inputs: Map_Search_CoordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đến toạ độ ${i?.lat}, ${i?.lng}`)
};

/**

* @param {Map_Search_CoordsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const map_search_coords = /** @type {((inputs: Map_Search_CoordsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Search_CoordsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_map_search_coords(inputs)
});